/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { Locale, LocaleKeys } from '../locale';
import { PostSignInError } from './PostSignInError';

export class JumpChannelError extends PostSignInError {
    protected type: string = 'JumpChannelError';

    protected title: string = Locale.getString(LocaleKeys.JUMP_CHANNEL_ERROR_OVERLAY_TITLE);

    public constructor(
        code: string,
        message: string,
        description: string,
        title?: string,
        type?: string,
    ) {
        super(message, code);
        this.description = description;
        if (title) {
            this.title = title;
        }
        if (type) {
            this.type = type;
        }
    }

    public getDescription(): string {
        return this.description;
    }

    public getTitle(): string {
        return this.title;
    }

    public getType(): string {
        return this.type;
    }
}
